export const X_Link = "https://x.com/CorePassCC";
export const Facebook_Link = "https://www.facebook.com/CorePassCC";
export const Linkedin_Link = "https://www.linkedin.com/company/corepass";
export const Instagram_Link = "https://www.instagram.com/corepasscc/";
export const YouTube_Link = "https://www.youtube.com/@CorePass";
export const Google_Play_Link =
  "https://play.google.com/store/apps/details?id=net.corepass.app";
export const App_Store_Link =
  "https://apps.apple.com/app/corepass-id/id1644928641";
export const Aptoide_Link = "https://corepass.en.aptoide.com/app";
export const Privacy_Policy_Link =
  "https://drive.google.com/file/d/189OJkNuDRoFo8LHzwhA_vXN1CtYaMMq-/view";
export const Terms_Conditions_Link =
  "https://drive.google.com/file/d/1_VFauLUhnQECQuGKjQoepE2ut5l-G_vK/view";
export const Contact_Us_Link = "mailto:contact@corepass.net";
export const Get_In_Touch_Link = "mailto:contact@corepass.net";
export const Learn_More_Link = "https://docs.corepass.net/";
export const Connector_Docs_Link = "https://docs.corepass.net/";
export const Connector_Contact_Link = "mailto:contact@corepass.net";
export const ROUTENAMES = {
  Privacy: "/privacy-policy",
  RootPage: "/",
  TermsConditions: "/terms-conditions",
  Connector: "/connector",
};

// The header, the footer and the drawer all render this same list. It used to
// be copy-pasted into each of the three; it lives here so a new entry is added
// once. An item with a `route` navigates; an item without one scrolls the
// landing page to the matching `sectionRef` key.
export const NAVIGATION_ITEMS = [
  { name: "About CorePass" },
  { name: "Features" },
  { name: "Business" },
  { name: "Connector", route: ROUTENAMES.Connector },
  { name: "Ecosystem" },
  { name: "Contact" },
];
